<template>
  <div class="page-main-bg">
    <v-container class="main-container">
      <!--tool-bar-->
      <ToolBar v-bind="toolBarProps" />

      <!--Filters-->
      <AccountFilter
        class="mb-6"
        ref="filter"
        :gridView="!tableView[$route.name]"
        :accountTypes="accountTypes"
        @changeGridView="updateSetTableView($route.name, $event)"
        @setFilters="setFilters"
      />

      <!--Loader-->
      <loader v-if="isPageLoading" v-bind="loaderProps" class="mt-2" />

      <!--no accounts-->
      <no-data v-else-if="!accounts.length" v-bind="noDataProps" />

      <template v-else>
        <!--Statistics-->
        <AccountStatistics class="mb-4" />

        <!--accounts-->
        <v-row v-if="!tableView.accounts">
          <v-col
            v-for="account in accounts"
            :key="account._id"
            col="12"
            md="6"
            lg="3"
          >
            <AccountCard :account="account" />
          </v-col>
        </v-row>

        <DataTableAccounts
          v-else
          :accounts="accounts"
          :accountsView="true"
          @toggleActivation="toggleActivation"
          @archiveAccount="getAccountsTable(true)"
          @editAccount="setSelectedAccount"
        />

        <!------------------------------>
        <!--------Pagination------------>
        <!------------------------------>

        <div class="text-center mt-6 mb-5" v-show="!!pagination.pagesCount">
          <Pagination
            :pagination="pagination"
            @onChange="getAccountsTable(false)"
          />
        </div>
      </template>

      <!----------------------------->
      <!------ Add client modal ----->
      <!----------------------------->

      <AddAccountModal
        v-if="dialogState"
        :dialogState="dialogState"
        :accountTypes="accountTypes"
        :editedAccount="selectedAccount"
        @close-account-dialog="setDialogState(false)"
        @refresh-accounts-list="getAccountsTable"
      />

      <!------------------------------------------------------->
      <!-------User actions (addClient & fastActions)---------->
      <!------------------------------------------------------->

      <div class="d-flex align-center justify-end ml-md-8 fast-actions">
        <v-btn
          data-test="openModal"
          @click="setDialogState(true)"
          class="font-weight-bold fast-actions-btn pa-5 font-12"
          color="primary"
          large
        >
          <img
            class="mx-2 icon-invert"
            src="@/assets/Icons_Legacy/strongbox.svg"
            loading="lazy"
          />
          إضافة حساب
        </v-btn>

        <!----------------------------->
        <!-------Fast actions---------->
        <!----------------------------->
        <FastActions />
      </div>
    </v-container>
  </div>
</template>

<script>
import ToolBar from '@/components/listing/ToolBar'
import AccountFilter from '@/components/accounts/AccountFilter'
import Pagination from '@/components/helper/pagination.vue'
import loader from '@/components/helper/loader.vue'
import noData from '@/components/helper/noData.vue'
import AccountStatistics from '../../components/accounts/AccountStatistics.vue'
import AccountCard from '../../components/accounts/AccountCard.vue'
import DataTableAccounts from '../../components/accounts/DataTableAccounts.vue'
import FastActions from '../../components/helper/fastActions.vue'

import setView from '@/mixins/setView'
import getAccountTypes from '@/mixins/getAccountTypes'
import { getAccountsTableView } from '@/services/accounts.service'
import cleanObject from '@/utils/cleanObject'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Accounts',
  components: {
    ToolBar,
    loader,
    noData,
    AccountFilter,
    Pagination,
    AccountStatistics,
    AccountCard,
    DataTableAccounts,
    FastActions,
    AddAccountModal: () =>
      import('../../components/accounts/AddAccountModal.vue')
  },
  mixins: [setView, getAccountTypes],
  data() {
    return {
      breadcrumbs: [
        {
          text: 'المالية ',
          disabled: true
        },
        { text: 'الحسابات', disabled: true }
      ],
      pageTitle: 'الحسابات',
      accounts: [],
      isPageLoading: false,
      noDataConfig: {
        text: 'لا توجد حسابات مضافه حتي الأن',
        subTitle: 'تكون كل الحسابات الصادرة المتاحة في هذة القائمة للعرض'
      },
      dialogState: false,
      selectedAccount: {},
      pagination: {
        pageNumber: 1,
        pagesCount: 0,
        pageSize: 10
      },
      filters: { filter: {} }
    }
  },
  computed: {
    ...mapState('accountState', ['currentEnv']),
    toolBarProps() {
      return {
        breadcrumbs: this.breadcrumbs,
        title: this.pageTitle
      }
    },
    loaderProps() {
      return {
        numberOfLines: 8,
        laoderClasses: 'mx-auto',
        type: 'card'
      }
    },
    noDataProps() {
      return {
        noDataText: this.noDataConfig.text,
        noDataSubTitle: this.noDataConfig.subTitle,
        noDataIcon: require('@/assets/Icons_Legacy/money.svg')
      }
    }
  },
  methods: {
    ...mapMutations('appState', ['addNotification']),
    setDialogState(val) {
      this.dialogState = val
      !val &&
        Object.keys(this.selectedAccount).length &&
        (this.selectedAccount = {})
    },
    setSelectedAccount(account) {
      this.selectedAccount = account
      this.setDialogState(true)
    },
    setFilters(filters) {
      this.filters = cleanObject(filters)
      this.getAccountsTable(true)
    },
    async getAccountsTable(resetPageNumber = false) {
      try {
        this.isPageLoading = true
        resetPageNumber && (this.pagination.pageNumber = 1)
        const { pageNumber, pageSize } = this.pagination
        const { data } = await getAccountsTableView(this.currentEnv._id, {
          page: pageNumber,
          size: pageSize,
          ...this.filters
        })
        this.accounts = data.data.content
        this.pagination.pagesCount = Math.ceil(data.data.total / pageSize)
      } catch {
        this.addNotification({
          text: 'خطأ في تحميل بيانات الحسابات',
          color: 'error'
        })
      } finally {
        this.isPageLoading = false
      }
    },
    toggleActivation({ index, isActive }) {
      this.$set(
        this.accounts[index],
        'status',
        isActive ? 'inactive' : 'active'
      )
    }
  },
  created() {
    this.getAccountsTable()
    this.getTypes()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/material-dashboard/fastactions.scss';
</style>

<style lang="scss" scoped>
@import '@/styles/material-dashboard/fastactions.scss';
</style>
